import * as React from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import { useNavigate, useLocation } from 'react-router-dom';
import { BottomNavigation, BottomNavigationAction, Box, Divider, Slide  } from '@mui/material';
import ListComponentNav from "../ListComponentNav";
import DynamicIcon from "../../DynamicIcon";
import StyledDrawer from "./StyledDrawer";
import getActiveModules from "../../../Storages/getActiveModules";

const BottomMenu: React.FC = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const activeModules = getActiveModules()

    const [loggedOff, setLoggedOff] = React.useState(false);
    const [isDrawerVisible, setIsDrawerVisible] = React.useState(false);

    React.useEffect(() => {
        if (loggedOff) {
            navigate("/login");
        }
    }, [loggedOff, navigate]);

    const bottomNavigationItems = activeModules.slice(0, 3);

    const toggleDrawer = () => {
        setIsDrawerVisible(!isDrawerVisible);
    }

    const handleNavigation = (path:any) => {
        navigate(path);
    };

    return (
        <>
            <>
                <Slide direction="right" in={isDrawerVisible} mountOnEnter unmountOnExit>
                    <StyledDrawer variant="permanent" sx={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '80%',
                        zIndex: 2200,
                        height: '100vh',
                        backgroundColor: '#1c2e4a',
                        borderRight: 'none', // remove a borda direita cinza
                    }} open={isDrawerVisible} onClose={toggleDrawer}>
                        <div style={{
                            width: '100%',
                            textAlign: 'center',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor: '#1c2e4a',
                            borderRight: 'none', // remove a borda direita cinza
                        }}>
                            <img src="/img/logo_white.png" alt="TribuNex - Sistema de gestão tributária" style={{ width: 200, marginTop: '20px' }} />
                        </div>
                        <div style={{
                            padding: 16,
                            backgroundColor: '#1c2e4a',
                            borderRight: 'none', // remove a borda direita cinza
                        }}>
                            <Divider />
                            <ListComponentNav />
                        </div>
                    </StyledDrawer>
                </Slide>
            </>


            <Box
                sx={{
                    position: 'fixed',
                    bottom: 0,
                    left: 0,
                    width: '100%',
                    zIndex: 1100,
                    backgroundColor: 'white',
                    padding: 0,
                    margin: 0
                }}
            >
                <BottomNavigation
                    value={location.pathname}
                >

                    {bottomNavigationItems.map((item, index) => (
                        <BottomNavigationAction
                            key={index}
                            label={item.description}
                            icon={<DynamicIcon iconName={item.icon_name} marginRight={0} />}

                            onClick={() => handleNavigation(item.route_name)}
                        />
                    ))}

                    <BottomNavigationAction
                        key="drawerMenu"
                        label="Abrir Menu"
                        icon={<MenuIcon  />}
                        onClick={toggleDrawer}
                    />
                </BottomNavigation>
            </Box>

            {isDrawerVisible && (
                <StyledDrawer variant="persistent" open={isDrawerVisible}>
                    <div style={{ width: '90%', height: '90%', padding: 16, backgroundColor: 'white' }}>
                        <ListComponentNav />
                    </div>
                </StyledDrawer>
            )}
        </>
    );
}

export default BottomMenu
